<template>
    <div>
        <FullCalendar
            class="calendar"
            ref="fullCalendar"
            height="auto"
            content-height="auto"
            :scheduler-license-key="key"
            :dates-above-resources="true"
            :defaultView="config.defaultView"
            :header="config.header"
            :button-text="buttonText"
            :first-day="config.firstDay"
            :min-time="config.minTime"
            :max-time="config.maxTime"
            :business-hours="config.businessHours"
            :locale="config.locale"
            :all-day-slot="config.allDay"
            :views="config.views"
            :weekends="config.weekends"
            :resources="config.resources"
            :plugins="plugins"
            :events="events"
            :now-indicator="true"
            :title-format="{
                month: 'long',
                year: 'numeric',
                day: 'numeric',
                weekday: 'long'
            }"
            :dates-render="datesRender"
            @dateClick="dateClick">
        </FullCalendar>
        <Modal :calendar="cal" :view="view"></Modal>
    </div>
</template>

<script>
    import FullCalendar from '@fullcalendar/vue'
    import dayGridPlugin from '@fullcalendar/daygrid'
    import timeGridPlugin from '@fullcalendar/timegrid'
    import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid'
    import interactionPlugin from '@fullcalendar/interaction'
    import Modal from './Modal'
    import { CONFIG } from '../shared'
    import { mapState, mapGetters, mapActions } from 'vuex'
    import { dataService } from "../shared";

    export default {
        name: "Calendar",
        components: {
            FullCalendar,
            Modal
        },
        data() {
            return {
                key: '0594050789-fcs-1596113641', // Lizenz gekauft 30.07.2020
                config: CONFIG.calendar,
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    interactionPlugin,
                    resourceTimeGridPlugin
                ],
                // modal
                cal: {
                    date: new Date(),
                    title: '',
                    resource: '',
                    slots: [],
                    from: [],
                    to: [],
                },
                view: {
                    start: '',
                    end: '',
                }
            }
        },
        methods: {
            ...mapActions(['getEvents', 'setTimes']),
            async dateClick(arg)
            {
                if (arg.date < this.$moment.now()) {
                    alert(this.getLanguage.errors.past);
                    return;
                }

                // check if resource has own businessHours defined ...
                const resourceHours = this.config.resources.find(x => x.id === arg.resource.id).businessHours;
                const dayTimes = this.getTimes(this.$moment(arg.date).isoWeekday(), resourceHours);

                // start / end default times for modal
                const hour = this.$moment(arg.date).format('HH');

                let hour2 =  parseInt(hour) + 1;
                    hour2 = ('0' + hour2).substr(-2); // change hours before 10 with leading 0

                const times = {
                    start: hour + ':00:00',
                    end: hour2 + ':00:00'
                }

                // check if selection is possible, based on time definitions in businessHours
                if (times.start < dayTimes.minTime || times.end > dayTimes.maxTime) {
                    alert(this.getLanguage.errors.overlap);
                    return;
                }

                // set start / end in vuex store
                this.setTimes(times);

                // reset
                this.cal.slots = [];
                this.cal.from = [];
                this.cal.to = [];

                this.cal.date = arg.date;
                this.cal.title = arg.resource.title;
                this.cal.resource = arg.resource.id;

                // slots
                this.cal.slots = await dataService.getSlots({
                    minTime: dayTimes.minTime,
                    maxTime: dayTimes.maxTime,
                    date: this.$moment(arg.date).format('YYYY-MM-DD'),
                    resource: arg.resource.id
                });

                if (this.hasSlots) {
                    await this.options(this.getSlotsAvailable, 'from');
                    await this.options(this.getSlotsAvailable, 'to');
                }

                // console.log("Times: " + JSON.stringify(times));
                // console.log("Von: " + JSON.stringify(this.cal.from));
                // console.log("Bis: " + JSON.stringify(this.cal.to));

                if (this.getUserId > 0) {
                    this.$bvModal.show('modal-reservation');
                } else {
                    this.$bvModal.show('modal-registerinfo');
                }
            },
            async options(sel, dest)
            {
                let i = 0;

                for (let prop in sel) {
                    if (sel.hasOwnProperty(prop)) {
                        this.cal[dest][i] = sel[prop][dest];
                        i++;
                    }
                }
            },
            getTimes(day, resource)
            {
                const businessHours = typeof resource !== "undefined" ? [ resource ] : this.config.businessHours;

                let times = businessHours.filter(time => time.daysOfWeek.find(el => el == day));

                if (times.length > 0) {
                    return { minTime: times[0].startTime, maxTime: times[0].endTime }
                }

                return { minTime: this.config.minTime, maxTime: this.config.maxTime };
            },
            async datesRender(arg)
            {
                const s = this.$moment(arg.view.activeStart).format('YYYY-MM-DD');
                const e = this.$moment(arg.view.activeEnd).format('YYYY-MM-DD');

                this.view.start = s;
                this.view.end = e;

                await this.getEvents({ start: s, end: e });
            }
        },
        computed: {
            ...mapState(['userevents', 'events']),
            ...mapGetters(['getUserId', 'userIsAdmin', 'getLanguage', 'getLangCode']),
            getSlotsAvailable()
            {
                return this.cal.slots.available;
            },
            hasSlots()
            {
                return this.cal.slots.length != 0 ? true : false;
            },
            buttonText()
            {
                const index = this.config.buttonText.indexOf(this.getLangCode) < 0 ? 0 : this.config.buttonText.indexOf(this.getLangCode);

                return this.config.buttonText[index + 1];
            }
        }
    }
</script>

<style lang='scss'>
    @import '~@fullcalendar/core/main.css';
    @import '~@fullcalendar/daygrid/main.css';
    @import '~@fullcalendar/timegrid/main.css';
</style>